/** Shared update UI phase — keep notification + Settings in sync. */

export function compareVersions(v1, v2) {
  const parts1 = String(v1 || '0').split('.').map((n) => parseInt(n, 10) || 0);
  const parts2 = String(v2 || '0').split('.').map((n) => parseInt(n, 10) || 0);
  const len = Math.max(parts1.length, parts2.length);

  for (let i = 0; i < len; i += 1) {
    const p1 = parts1[i] || 0;
    const p2 = parts2[i] || 0;
    if (p1 < p2) return -1;
    if (p1 > p2) return 1;
  }
  return 0;
}

export function isUpdateVersionNewer(updateVersion, currentVersion) {
  if (!updateVersion || !currentVersion) return false;
  return compareVersions(updateVersion, currentVersion) > 0;
}

/** Ignore stale pending downloads (e.g. v0.1.12 file after manual install of v0.1.15). */
export function resolveUpdateUiPhase(status) {
  if (!status || typeof status !== 'object') return 'idle';

  const currentVersion = status.currentVersion;
  const offeredVersion = status.version;

  if (
    offeredVersion &&
    currentVersion &&
    !isUpdateVersionNewer(offeredVersion, currentVersion)
  ) {
    return 'idle';
  }

  const phase = status.phase;
  if (phase === 'checking') return 'checking';
  if (phase === 'downloading' || status.isDownloading) return 'downloading';
  if (phase === 'installing') return 'installing';
  if (phase === 'ready') return 'ready';
  if (phase === 'available' || status.updateAvailable) return 'available';
  if (phase === 'error') return 'error';
  return 'idle';
}

export function shouldShowUpdateActions(status) {
  const phase = resolveUpdateUiPhase(status);
  return phase === 'available' || phase === 'ready';
}
